import { Box, Button, Dialog, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import dangerIcon from "../../asserts/logo/Danger.svg";
import { BTN_TEXT_SX, PRIMARY_BTN_SX } from "./gate2Tokens";

/**
 * Shown when execution cannot reach the declared vector database.
 *
 * Raised once for the whole run rather than per test case: if the host or
 * password is wrong, every case would fail identically and a wall of rows
 * would bury the one thing the user has to fix.
 */
export default function VectorConnectionAlert({ alert, onClose, onAction }) {
  const open = Boolean(alert);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          borderRadius: "8px",
          width: { xs: "calc(100% - 32px)", sm: 520 },
          maxWidth: 520,
          p: 4,
          position: "relative",
          boxShadow: "0px 10px 10px 0px rgba(0, 0, 0, 0.24)",
        },
      }}
      slotProps={{ backdrop: { sx: { bgcolor: "rgba(52, 64, 84, 0.45)" } } }}
    >
      <IconButton
        size="small"
        onClick={onClose}
        aria-label="Close"
        sx={{ position: "absolute", top: 8, right: 8, color: "#555555" }}
      >
        <CloseIcon sx={{ fontSize: 24 }} />
      </IconButton>

      <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
        <Box sx={{ position: "relative", width: 64, height: 64, flexShrink: 0 }}>
          <Box
            component="img"
            src={dangerIcon}
            alt=""
            sx={{
              position: "absolute",
              top: "12.8px",
              left: "10.67px",
              width: "43px",
              height: "39px",
              display: "block",
            }}
          />
        </Box>

        <Typography
          sx={{
            fontFamily: "Lato, sans-serif",
            fontWeight: 900,
            fontSize: "20px",
            lineHeight: "27px",
            color: "#000000",
            textAlign: "center",
          }}
        >
          {alert?.title || "Cannot connect to the vector database"}
        </Typography>

        <Typography
          sx={{
            fontFamily: "Lato, sans-serif",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "21px",
            color: "#555555",
            textAlign: "center",
          }}
        >
          {alert?.message ||
            "Provide valid vector database connection details before starting execution."}
        </Typography>

        {alert?.details ? (
          <Box
            sx={{
              width: "100%",
              bgcolor: "#FEF2F2",
              border: "1px solid #FECACA",
              borderRadius: "6px",
              px: 2,
              py: 1.5,
            }}
          >
            {alert.details.provider ? (
              <Typography
                sx={{
                  fontFamily: "Lato, sans-serif",
                  fontSize: 11,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.4px",
                  color: "#B91C1C",
                  mb: 0.5,
                }}
              >
                {alert.details.provider}
                {alert.details.type ? ` · ${alert.details.type}` : ""}
              </Typography>
            ) : null}
            <Typography
              sx={{
                fontFamily: "Lato, sans-serif",
                fontSize: 13,
                lineHeight: "20px",
                color: "#7F1D1D",
                wordBreak: "break-word",
              }}
            >
              {alert.details.message}
            </Typography>
          </Box>
        ) : null}

        <Button
          variant="contained"
          disableElevation
          onClick={onAction || onClose}
          sx={{ ...PRIMARY_BTN_SX, ...BTN_TEXT_SX, mt: 1 }}
        >
          {alert?.actionLabel || "Update connection details"}
        </Button>
      </Box>
    </Dialog>
  );
}
